export default "__VITE_ASSET__Bi5lZrf$__"